import React, { Component } from 'react';

// Components
import { Grid } from '@material-ui/core';
import { T } from 'Actions/translate';
import Dialog from 'Components/common/Dialog';
import BasicButton from 'Components/common/BasicButton';
import Table from 'Components/common/TableWrapper';

class CommonDialogWrapper extends Component {

	state = {
		exitOpened: false
	}

	openDialog = (name, id) => {
        this.props.handleChange(name, id)
	}

	closeDialog = (name) => {
		this.props.closeDialog(name);
	}

	render() {
		const { exitOpened, skuReplenishmentDetailData, tableThContent } = this.props;
		
		return (
			<Dialog dialogDidClose={()=>this.closeDialog('exitOpened')} opened={exitOpened} options={{ bgClickClose: true }}>
					<div className='logout-dialog'>
						<Grid className='dialog-title' container spacing={0}>
							<Grid item xs={12}>
								<span>{ T('fone_order_shippment_details') }</span>
							</Grid>
						</Grid>

						<Grid className='dialog-content shipping-details-dialog-content' container spacing={0} justify={'center'}>
							<Grid item xs={12} className='simple-table-setting'>
								<Table skuReplenishmentDetailList={skuReplenishmentDetailData.data} tableThContent={tableThContent}>
								</Table>
							</Grid>
						</Grid>

						<Grid container spacing={0}>
							<Grid item xs={12} align="center">
								<BasicButton className="close-confirm-btn" type="primary" disabled={ false } onClickOfSingleTap={()=>this.closeDialog('exitOpened')}>
									<span>{ T('shopping_cart_close') }</span>
								</BasicButton>
							</Grid>
						</Grid>
					</div>
			</Dialog>
		)
	}
}


export default CommonDialogWrapper;
